import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from '../common/history';
import homeReducer from '../features/home/redux/reducer';
import dashboardReducer from '../features/dashboard/redux/reducer'
import commonReducer from '../features/common/redux/reducer';
import carDataMasterReducer from '../features/car-data-master/redux/reducer';
import carDataCatalogoReducer from '../features/car-data-catalogo/redux/reducer';
import stockReducer from '../features/stock/redux/reducer';
import vistaVendedorReducer from '../features/vista-vendedor/redux/reducer';
import simuladorFinancieroReducer from '../features/simulador-financiero/redux/reducer';
import comparadorReducer from '../features/comparador/redux/reducer';
import peritadorReducer from '../features/peritador/redux/reducer';
import presupuestadorReducer from '../features/presupuestador/redux/reducer';
import cotizadorReducer from '../features/cotizador/redux/reducer';
import gestionOperativaReducer from '../features/gestion-operativa/redux/reducer';
import clientesReducer from '../features/clientes/redux/reducer';
import precioJustoReducer from '../features/precio-justo/redux/reducer';
import usuariosReducer from '../features/usuarios/redux/reducer';
import perfilesReducer from '../features/perfiles/redux/reducer';
import gastosGestoriaReducer from '../features/gastos-gestoria/redux/reducer';
import compraUsadosReducer from '../features/compra-usados/redux/reducer';
import commissionsReducer from '../features/commissions/redux/reducer';
import pricePoliciesReducer from '../features/price-policies/redux/reducer';
import paymentsReducer from '../features/payments/redux/reducer';
import leadsReducer from '../features/leads/redux/reducer';
import savingsPlanSubscriptionReducer from '../features/savings-plan-subscription/redux/reducer' 

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: connectRouter(history),
  home: homeReducer,
  common: commonReducer,
  carDataMaster: carDataMasterReducer,
  carDataCatalogo: carDataCatalogoReducer,
  dashboard : dashboardReducer,
  stock: stockReducer,
  vistaVendedor: vistaVendedorReducer,
  simuladorFinanciero: simuladorFinancieroReducer,
  comparador: comparadorReducer,
  peritador: peritadorReducer,
  presupuestador: presupuestadorReducer,
  cotizador: cotizadorReducer,
  gestionOperativa: gestionOperativaReducer,
  clientes: clientesReducer,
  precioJusto: precioJustoReducer,
  usuarios: usuariosReducer,
  perfiles: perfilesReducer,
  gastosGestoria: gastosGestoriaReducer,
  compraUsados: compraUsadosReducer,
  commissions: commissionsReducer,
  pricePolicies: pricePoliciesReducer,
  payments: paymentsReducer,
  leads: leadsReducer,
  savingsPlanSubscription: savingsPlanSubscriptionReducer
};

export default combineReducers(reducerMap);
